import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import authEn from './locales/en/auth.json';
import authEs from './locales/es/auth.json';

const Languages = ['en', 'es'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        auth: authEn,
      },
      es: {
        auth: authEs,
      },
    },
    fallbackLng: 'en',
    supportedLngs: Languages,
    cleanCode: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'htmlTag', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      htmlTag: document.documentElement,
    },
  });

export default i18n;
